import React from "react";
import Spinner from "../../../Components/Spinner";
import { useGetNotificationQuery } from "../../../../../redux/services/internal/apiHome";
import InnerBanner from "../../../Components/InnerBanner";
import BreadCrumb from "../../../Components/BreadCrumb";

const HomeNotification = ({ benchId }) => {
  
 
  const {
    data: dataNews,
    isLoading,
    isError,
  } = useGetNotificationQuery(benchId);




  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error fetching gallery data!</div>;
  }
  return (
    <>
      <InnerBanner title="Notification" />
      <BreadCrumb title="Notification" />
      <div className="about-bg inner-page-section mt-4">
      <div className="container">
      <div className="row">
        {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4 d-flex justify-content-between align-items-center">
          <div className="w-75 mw-50">
            <h2>Notification</h2>
          </div>
        </div> */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
          <div className="table-responsive">
            <table className="table table-striped common-table tender">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Notice Title </th>
                  <th>Date </th>
                  <th>Document</th>
                </tr>
              </thead>
              <tbody>
                {dataNews?.status && dataNews?.data?.length > 0 ? (
                  dataNews?.data.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.title}</td>
                      <td>{item.events_from_date}</td>
                      <td className="text-center">
                        {item.upload_image_path ? (
                          <a
                            target="_blank"
                            href={item.upload_image_path}
                            rel="noopener noreferrer"
                          >
                            <i className="fas fa-file-pdf"></i>
                          </a>
                        ) : (
                          "No Document"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No Record Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
      </div>
    </>
  );
};

export default HomeNotification;
